<template>
            
    <emc-chart-apex-base :series="series" type="line" :options="chartOptions" :loading.sync="loading">

        <template v-slot:actions>

            <emc-chart-filter :show.sync="showFilter" @filter="filter($event)" />

            <emc-chart-refresh-status :label="statusLabel" :failed="hasFailed" :error-code="errorCode" />

            <v-spacer></v-spacer>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" color="primary" v-on="on" icon @click="showFilter = true">
                        <v-icon btn>mdi-filter-outline</v-icon>
                    </v-btn>
                </template>
                <span>
                    Selecionar Categorias
                </span>
            </v-tooltip>
            <emc-button-icon btn-small :disabled="isBusy" icon="mdi-refresh-circle" :text="updated_at || `Atualizar`" color="success" @click.prevent.stop="start()" />
        </template>

    </emc-chart-apex-base>

</template>

<script>

import { getCurrentInstance } from 'vue'
import { mapActions } from 'vuex'
import { useChartRefresh } from '@/composables/useChartRefresh'

export default {
    name: 'EmcChartEfficiencyOfWorkload',
    setup() {
        const { proxy } = getCurrentInstance()

        return useChartRefresh({
            refreshAction: 'chart/ActionEfficiencyOfWorkloadRefresh',
            onFinished: () => proxy.getData()
        })
    },
    data () {
        return {
            // Só a busca de dados: durante a recarga o gráfico continua
            // visível com o indicador ao lado, em vez de virar esqueleto.
            loading: false,
            showFilter: false,
            filterPayload: {},
            series: [],
            chartOptions: {
                chart: {
                stacked: true,
                zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: true
                    }
                },
                stroke: {
                    width: [0, 0]
                },
                title: {
                    text: ''
                },
                labels: [],
                colors: [],
            yaxis: [{
              title: {
                text: 'Carga horária',
              },
            
            }],
            fill: {
              opacity: 1
            }
          },
            updated_at: null,

            name: 'EfficiencyOfWorkload',
            chartData: []
        }
    },
    props: {
        itemId: {
            type: Number,
        },
    },
    methods: {
        ...mapActions('chart', ['ActionChartEfficiencyOfWorkload']),
        async getData() {

            this.loading = true

            //buscando dados do gráfico
            await this.ActionChartEfficiencyOfWorkload(this.filterPayload)
                .then((r) => {
                    this.series = r.data.series
                    this.chartOptions.labels = r.data.categories
                    this.chartOptions.colors = r.data.colors
                    this.chartOptions.title.text = r.data.title
                    this.updated_at = r.data.updated_at

                    // Recarga já em andamento (normalmente a carga noturna):
                    // o gráfico mostra o andamento sem o usuário ter clicado.
                    this.adopt(r.data.refresh)
                })
                .finally(() => {
                    this.loading = false
                })

        },
        filter(ev){
            this.filterPayload = ev;
            this.showFilter = false;
            this.getData();
        },
    },

    created() {
        this.getData()
    }
}
</script>